export default __webpack_public_path__ + "static/media/ai_face_detection.d41ae68e.svg";